import React from "react";
import { useFormik } from "formik";
import apiRequest from "../../../utils/corporateAdmin/apiRequest";
import InputField from "../../ui/form/InputField";
import Button from "../../ui/utils/Button";
import SelectField from "../../ui/form/SelectField";
import usePost from "../../../hooks/api/usePost";
import Alert from "../../ui/utils/Alert";
import { VendorUpdateValidationSchema } from "../../../validation/corporateAdmin/vendoValidation";
import useFetch from "../../../hooks/api/useFetch";
import { useEffect } from "react";

const EditVendorStaff = ({ data, closeModal, callback }) => {
  const {
    error,
    isLoading: loading,
    post,
    serverErrors,
  } = usePost(apiRequest.editVendor);
  const formik = useFormik({

    initialValues: {
      name: data?.name,
      countryId: data?.countryId?._id,
      cityId: data?.city?._id,
      stateId: data?.stateId?._id,
      corporateName: data?.corporateName,
      corporateCode: data?.corporateCode,
      mobile: data?.mobile,
      email: data?.email,
      contactPerson: data?.contactPerson,
      vendorType: data?.vendorType,
      password: null,
      userId: data?.userId,
      isSuperVendor: false

    },

    validationSchema: VendorUpdateValidationSchema,

    onSubmit: async (values, { resetForm }) => {
      const response = await post({ data: { body: values, id: data?._id } });
      if (response.response) {
        callback?.();
        resetForm();
        closeModal();
      }
    },
  });


  const { data: countryData } = useFetch({
    apiMethod: apiRequest.getCountry,
    body: { paginate: false, sortField: "name", sortOrder: "asc" },
  });

  const {
    data: stateData,
    refetch: fetchStates,
    setBlankResponse,
  } = useFetch({
    apiMethod: apiRequest.getStateByCountryId,
    body: { paginate: false, sortField: "name", sortOrder: "asc" },
    autoFetch: false,
  });

  const {
    data: cityData,
    refetch: fetchCities,
    setBlankResponse: setCityBlankResponse,
  } = useFetch({
    apiMethod: apiRequest.getCityByState,
    body: { paginate: false, sortField: "name", sortOrder: "asc" },
    autoFetch: false,
  });


  useEffect(() => {
    const countryId = formik.values.countryId;

    if (countryId) {
      fetchStates({ countryId });
      formik.setFieldValue("stateId", data?.stateId?._id);
    } else {
      setBlankResponse();
    }
  }, [formik.values.countryId, data?.countryId?._id]);

  useEffect(() => {
    const stateId = formik.values.stateId;
    if (stateId) {
      fetchCities({ stateId });
      formik.setFieldValue("cityId", data?.cityId?._id);
    } else {
      setCityBlankResponse();
    }
  }, [formik.values.stateId, data?.stateId?._id]);

  const { data: adminList } = useFetch({
    apiMethod: apiRequest.getHeadVendors,
    body: { paginate: false, sortField: "name", sortOrder: "asc" },
    autoFetch: true,
  });
  
  return (
    <div>
      <h2 className="p-4 text-lg font-semibold">Update Coupon</h2>
      <div className="border-b" />
      <form onSubmit={formik.handleSubmit} className="text-sm">
        {error && <Alert message={error} type="error" />}
        <div className="grid grid-cols-1 gap-2 p-4 sm:grid-cols-2">

          <SelectField
            name="addedBy"
            label="Main Vendor"
            placeholder="Select Main Vendor"
            value={formik.values.addedBy}
            onChange={formik.handleChange}
            options={adminList?.vendors?.map((item) => ({
              value: item._id,
              label: item.name,
            }))}
          />

          <InputField
            name="name"
            label="Vendor Name"
            placeholder="Enter vendor name"
            value={formik.values.name}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={formik.touched.name && formik.errors.name}
            serverError={serverErrors?.name}
          />
          <InputField
            name="mobile"
            label="Mobile"
            placeholder="Enter mobile"
            value={formik.values.mobile}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={formik.touched.mobile && formik.errors.mobile}
            serverError={serverErrors?.mobile}
          />

          <InputField
            name="email"
            label="Email"
            placeholder="Enter email"
            value={formik.values.email}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={formik.touched.email && formik.errors.email}
            serverError={serverErrors?.email}
          />

          <SelectField
            name="countryId"
            label="Country"
            placeholder="Select Country"
            value={formik.values.countryId}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            serverError={serverErrors?.countryId}
            error={formik.touched.countryId && formik.errors.countryId}
            options={countryData?.countries?.map((item) => ({
              value: item._id,
              label: item.name,
            }))}
          />

          <SelectField
            name="stateId"
            label="State"
            placeholder="Select State"
            value={formik.values.stateId}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            serverError={serverErrors?.stateId}
            error={formik.touched.stateId && formik.errors.stateId}
            options={stateData?.states?.map((item) => ({
              value: item._id,
              label: item.name,
            }))}
          />

          <SelectField
            name="cityId"
            label="City"
            placeholder="Select city"
            value={formik.values.cityId}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            serverError={serverErrors?.cityId}
            error={formik.touched.cityId && formik.errors.cityId}
            options={cityData?.cities?.map((item) => ({
              value: item._id,
              label: item.name,
            }))}
          />





          <InputField
            name="corporateName"
            label="Corporate Name"
            placeholder="Enter corporate name"
            value={formik.values.corporateName}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={formik.touched.corporateName && formik.errors.corporateName}
            serverError={serverErrors?.corporateName}
          />

          <InputField
            name="corporateCode"
            label="Corporate Code"
            placeholder="Enter corporate code"
            value={formik.values.corporateCode}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={formik.touched.corporateCode && formik.errors.corporateCode}
            serverError={serverErrors?.corporateCode}
          />



          <InputField
            name="contactPerson"
            label="Contact Person"
            placeholder="Enter contact person"
            value={formik.values.contactPerson}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={formik.touched.contactPerson && formik.errors.contactPerson}
            serverError={serverErrors?.contactPerson}
          />

          <InputField
            name="vendorType"
            label="Vendor Type"
            placeholder="Enter vendor type"
            value={formik.values.vendorType}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={formik.touched.vendorType && formik.errors.vendorType}
            serverError={serverErrors?.vendorType}
          />

          <InputField
            type="password"
            name="password"
            label="Password"
            placeholder="Enter password"
            value={formik.values.password}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={formik.touched.password && formik.errors.password}
            serverError={serverErrors?.password}
          />

          {/* <InputField
            name="addedBy"
            label="Added By"
            placeholder="Added by ID"
            value={formik.values.addedBy}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={formik.touched.addedBy && formik.errors.addedBy}
            serverError={serverErrors?.addedBy}
          /> */}

          <InputField
            name="userId"
            label="User ID"
            placeholder="Enter user ID"
            value={formik.values.userId}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={formik.touched.userId && formik.errors.userId}
            serverError={serverErrors?.userId}
          />


        </div>


        <div className="border-b" />
        <div className="flex justify-end gap-2 p-4">
          <Button variant="secondary" onClick={closeModal}>
            Cancel
          </Button>
          <Button
            type="submit"
            variant="primary"
            loadingText="Updating..."
            isLoading={loading}
          >
            Update
          </Button>
        </div>
      </form>
    </div>
  );
};

export default EditVendorStaff;
